<template>
	<div class="main" :class="{ iframe }">
		<loading :active="isLoading" background-color="transparent" is-full-page>
			<i class="fas fa-spinner fa-pulse" style="color: #007bff; font-size: 100px"></i>
		</loading>
		<b-container class="content" v-if="ready">
			<div class="white-background">
				<b-row class="votaciones-stats mx-md-auto">
					<b-col class="mb-3 mb-md-0" cols="12" md="6">
						<div class="votaciones-stats-percentage-container">
							<span>Porcentaje mesas escrutadas</span>
							<span class="votaciones-stats-percentage">{{ data.oldEleccion ? data.oldEleccion.porcentaje : 0 }}%</span>
						</div>
						<div class="votaciones-stats-national-text">Nivel nacional</div>
						<b-progress :value="data.oldEleccion ? data.oldEleccion.porcentaje : 0" max="100"></b-progress>
					</b-col>
					<b-col class="votaciones-stats-info" cols="12" md="6">
						<p class="votaciones-stats-last-update">
							Última actualización: <strong class="votaciones-stats-last-update-date">{{ updateDate }}</strong>
						</p>
						<p class="votaciones-stats-info-text">Resultados parciales. Fuente: SERVEL</p>
					</b-col>
				</b-row>
			</div>
			<div class="white-background">
				<b-row class="votaciones mx-md-auto" v-if="votaciones">
					<b-col
						v-for="(votacion, index) in votaciones"
						cols="12"
						:md="index === 0 ? 12 : 6"
						:key="votacion.zona.cod_zona"
					>
						<div class="votacion" :class="{ 'votacion-big': index === 0 }">
							<h2 class="votacion-title">{{ votacion.zona.glosa_zona }}</h2>
							<div class="candidatos-container">
								<div
									class="candidato candidato-left"
									:class="{ 'candidato-ganador': electos[votacion.candidatoA.cod_cand] }"
								>
									<div class="ganador-badge">{{ votacion.candidatoA.cod_genero === 'F' ? 'GANADORA' : 'GANADOR' }}</div>
									<img class="candidato-img" :src="`${imgPath}${votacion.candidatoA.cod_cand}.png`" />
									<div class="candidato-stats">
										<div class="candidato-percentage">
											{{
												votacion.validos ? percentage(votacion.candidatoA.votos, votacion.validos) : 0 | formatNumber
											}}%
										</div>
										<div class="candidato-votos">
											<strong>{{ votacion.candidatoA.votos | formatNumber }}</strong> votos
										</div>
									</div>
								</div>
								<div
									class="candidato candidato-right"
									:class="{ 'candidato-ganador': electos[votacion.candidatoB.cod_cand] }"
								>
									<div class="ganador-badge">{{ votacion.candidatoB.cod_genero === 'F' ? 'GANADORA' : 'GANADOR' }}</div>
									<div class="candidato-stats">
										<div class="candidato-percentage">
											{{
												votacion.validos ? percentage(votacion.candidatoB.votos, votacion.validos) : 0 | formatNumber
											}}%
										</div>
										<div class="candidato-votos">
											<strong>{{ votacion.candidatoB.votos | formatNumber }}</strong> votos
										</div>
									</div>
									<img class="candidato-img" :src="`${imgPath}${votacion.candidatoB.cod_cand}.png`" />
								</div>
							</div>
							<b-progress
								:class="{ 'no-progress': !votacion.validos }"
								:value="votacion.validos ? percentage(votacion.candidatoA.votos, votacion.validos) : 0"
								max="100"
							></b-progress>
							<div class="candidatos-container">
								<div
									class="candidato candidato-left"
									:class="{ 'candidato-ganador': electos[votacion.candidatoA.cod_cand] }"
								>
									<div class="candidato-name">
										{{ votacion.candidatoA.glosa_cand | capitalize }}{{ '\xa0' }}<i class="fas fa-check"></i>
									</div>
								</div>
								<div
									class="candidato candidato-right"
									:class="{ 'candidato-ganador': electos[votacion.candidatoB.cod_cand] }"
								>
									<div class="candidato-name">
										<i class="fas fa-check"></i>{{ '\xa0' }}{{ votacion.candidatoB.glosa_cand | capitalize }}
									</div>
								</div>
							</div>
							<b-row class="votacion-stats mx-n1 mx-md-auto">
								<b-col v-if="votacion.valido !== null" class="votacion-stat px-1" cols="3">
									<p class="votacion-stat-name">Votos válidos:</p>
									<p class="votacion-stat-value">
										{{ votacion.validos | formatNumber }}
									</p>
								</b-col>
								<b-col v-if="votacion.blancos !== null" class="votacion-stat px-1" cols="3">
									<p class="votacion-stat-name">Blancos:</p>
									<p class="votacion-stat-value">
										{{ votacion.blancos | formatNumber }}
									</p>
								</b-col>
								<b-col v-if="votacion.nulos !== null" class="votacion-stat px-1" cols="3">
									<p class="votacion-stat-name">Nulos:</p>
									<p class="votacion-stat-value">
										{{ votacion.nulos | formatNumber }}
									</p>
								</b-col>
								<b-col class="votacion-stat px-1" cols="3">
									<p class="votacion-stat-name">Total votos:</p>
									<p class="votacion-stat-value">
										{{ votacion.total | formatNumber }}
									</p>
								</b-col>
							</b-row>
						</div>
					</b-col>
				</b-row>
			</div>
		</b-container>
	</div>
</template>

<script>
import { loadScheme, fetchVotacion, fetchActualizados, fetchElectos, fetchData } from '../data/data-gobernadores.js'
import { getCandidatos, getVotosGobernadores } from '../data/queries'
import alasql from 'alasql'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
	components: {
		Loading
	},
	props: {
		iframe: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			electos: {},
			data: null,
			ready: false,
			votaciones: null,
			loading: false,
			imgPath: `${process.env.VUE_APP_DATA_URL}gobernadores/img/`
		}
	},

	computed: {
		isLoading() {
			return !this.ready || this.loading
		},
		updateDate() {
			if (!this?.data?.oldEleccion) {
				return 'Datos aún no disponibles'
			}

			const date = new Date(+this.data.oldEleccion.timestamp * 1000)

			return `${date.getDate()}/${
				date.getMonth() + 1
			}/${date.getFullYear()} a las ${date.getHours()}:${date.getMinutes()}`
		}
	},
	created() {
		window.alasql = alasql
		window.getVotosGobernadores = getVotosGobernadores
		window.getCandidatos = getCandidatos
		this.loading = true

		Promise.all([fetchData(), fetchActualizados(), fetchElectos(), loadScheme()]).then(
			([data, elecciones, electos]) => {
				this.data = {
					regiones: data.regiones,
					newEleccion: elecciones[1],
					oldEleccion: elecciones[1]
				}
				this.electos = electos
				this.loading = false
				this.ready = true

				this.interval = setInterval(() => {
					fetchActualizados().then(elecciones => {
						this.data.newEleccion = elecciones[1]
						this.getVotacion(true)
					})

					fetchElectos().then(electos => (this.electos = electos))
				}, 60000)

				this.getVotacion()
			}
		)
	},
	destroyed() {
		clearInterval(this.interval)
	},
	methods: {
		getVotacion(automatic) {
			this.$nextTick(() => {
				const newEleccion = this.data.newEleccion
				const oldEleccion = this.data.oldEleccion

				/* En caso de que exista datos de la votación y la vieja votación no exista (Esto pasa cuando los datos de
				   la votación no existían en la ejecución anterior) o no se haya descargado aún o los datos son más recientes*/
				if (newEleccion && (!oldEleccion?.fetched || +oldEleccion.timestamp < +newEleccion.timestamp)) {
					this.loading = true
					this.votacion = null
					fetchVotacion(newEleccion.path, 1)
						.then(() => {
							this.data.oldEleccion = newEleccion
							this.data.oldEleccion.fetched = true
							this.setVotacion(this.data.oldEleccion)
							this.$nextTick(() => (this.loading = false))
						})
						.catch(err => {
							console.error(err)
							this.setVotacion(this.data.oldEleccion)
							this.$nextTick(() => (this.loading = false))
						})
				} else if (!automatic) {
					/* Cuando no existen datos de votación (Ej: el servel no ha enviado los datos aún) o los datos de la votación
					    anterior han sido descargados y aún no se han actualizado. Se verifica si existen datos ya descargados de la
						votación, si no existen de todas formas se pasa un objeto para que muestren los datos de los candidatos,
						con todos sus votos en 0 */
					this.votacion = null
					this.setVotacion(
						oldEleccion || {
							id: 1,
							path: null,
							timestamp: 0,
							porcentaje: 0,
							fdate: 0
						}
					)
				}
			})
		},
		setVotacion() {
			const votos = getVotosGobernadores()
			const votaciones = {}

			votos.forEach(votos => {
				if (!votaciones[votos.cod_zona]) {
					votaciones[votos.cod_zona] = {
						zona: this.data.regiones.find(region => region.cod_zona === votos.cod_zona),
						nulos: 0,
						blancos: 0,
						validos: 0,
						total: 0
					}
				}

				const votacion = votaciones[votos.cod_zona]

				if (votos.cod_cand !== 1) {
					if (votacion.candidatoA) {
						votacion.candidatoB = votos
					} else {
						votacion.candidatoA = votos
					}
				} else {
					switch (votos.glosa_cand) {
						case 'Nulos':
							votacion.nulos = votos.votos
							break
						case 'Blancos':
							votacion.blancos = votos.votos
							break
						case 'Votos válidos':
							votacion.validos = votos.votos
							break
					}
				}

				votacion.total = votacion.nulos + votacion.blancos + votacion.validos
			})

			this.votaciones = Object.values(votaciones).sort((a, b) => {
				if (a.zona.cod_zona === 3013) {
					return -1
				} else if (b.zona.cod_zona === 3013) {
					return 1
				}

				return a.zona.orden_zona - b.zona.orden_zona
			})

			if (window.parent) {
				window.parent.postMessage('show-data', '*')
			}
		},
		percentage(votos, total) {
			return (votos * 100) / total
		}
	}
}
</script>

<style scoped lang="scss">
.white-background {
	background-color: #fff;
}

.iframe .content {
	.votaciones {
		max-height: 358px;
		overflow: auto;
		position: relative;

		&::after {
			background: linear-gradient(to bottom, rgba(23, 42, 76, 0), rgba(#172a4c, 0.1));
			bottom: 0;
			content: '';
			display: block;
			height: 45px;
			left: 0;
			position: fixed;
			width: 100%;
			z-index: 10;
		}
	}
}

.votaciones-stats {
	background-color: #fff;
	margin-bottom: 10px;
	padding: 20px 0;

	.votaciones-stats-percentage-container {
		align-items: center;
		color: #172a4c;
		display: flex;
		justify-content: space-between;
		font-size: 16px;
		font-weight: bold;
		margin-bottom: 8px;
		line-height: 19px;

		.votaciones-stats-percentage {
			color: #0f6f5a;
			font-size: 18px;
			font-weight: bold;
			line-height: 22px;
			text-align: right;
		}
	}

	.votaciones-stats-national-text {
		color: #5c6981;
		font-size: 13px;
		line-height: 14px;
		margin-bottom: 12px;
	}

	.progress {
		background-color: rgba(#8899a6, 0.3);
	}

	.votaciones-stats-last-update,
	.votaciones-stats-info-text {
		color: #5c6981;
		font-size: 13px;
		line-height: 14px;
		text-align: center;
	}

	.votaciones-stats-last-update {
		margin-bottom: 10px;
	}

	.votaciones-stats-last-update-date {
		color: #172a4c;
	}

	.votaciones-stats-info-text {
		font-size: 12px;
		line-height: 15px;
		margin-bottom: 0;
	}
}

.votaciones {
	background-color: #fff;
	padding: 35px 0;

	[class^='col-'] {
		background: linear-gradient(#dbe0e4, #dbe0e4) bottom center / calc(100% - 30px) 1px no-repeat;
		margin-bottom: 36px;
		padding-bottom: 35px;
	}
}

.votacion {
	.votacion-title {
		color: #172a4c;
		font-size: 17px;
		font-weight: bold;
		line-height: 21px;
		margin-bottom: 4px;
		padding: 0 80px;
		text-align: center;
		position: relative;

		&::after {
			background-color: #368cf6;
			bottom: -16px;
			content: '';
			display: block;
			height: 2px;
			left: 50%;
			position: absolute;
			transform: translateX(-50%);
			width: 50px;
		}
	}

	.candidatos-container {
		display: flex;
		justify-content: space-between;

		.ganador-badge {
			border-radius: 2px;
			background-color: #05b879;
			display: none;
			color: #ffffff;
			font-size: 9px;
			font-weight: bold;
			line-height: 11px;
			padding: 3px 10px;
			position: absolute;
			top: -27px;
		}

		.fa-check {
			align-items: center;
			background-color: #18dc97;
			color: #fff;
			display: none;
			font-size: 9px;
			justify-content: center;
			border-radius: 50%;
			padding: 3px;
		}

		.candidato {
			display: flex;
			position: relative;

			&.candidato-ganador {
				.ganador-badge {
					display: block;
				}

				.candidato-name {
					white-space: nowrap;
				}

				.fa-check {
					display: inline-flex;
				}

				.candidato-img {
					opacity: 1;
				}
			}
		}

		.candidato-left {
			text-align: left;

			.ganador-badge {
				left: 0;
			}

			.candidato-percentage {
				color: #e55c5c;
			}

			.candidato-name {
				margin-right: 12px;
			}

			.candidato-img {
				margin-right: 12px;
			}
		}

		.candidato-right {
			text-align: right;

			.ganador-badge {
				right: 0;
			}

			.candidato-percentage {
				color: #69a5f0;
			}

			.candidato-name {
				margin-left: 12px;
			}

			.candidato-img {
				margin-left: 12px;
			}
		}

		.candidato-stats {
			display: flex;
			flex-direction: column;
			justify-content: flex-end;
			margin-bottom: 17px;
		}

		.candidato-percentage {
			font-size: 22px;
			font-weight: 900;
			line-height: 27px;
			margin-bottom: 9px;
		}

		.candidato-votos {
			color: #172a4c;
			font-size: 12px;
			line-height: 15px;
		}

		.candidato-name {
			color: #172a4c;
			font-size: 14px;
			line-height: 17px;
			margin-bottom: 20px;
		}

		.candidato-img {
			filter: grayscale(1);
			height: 107px;
			opacity: 0.5;
			width: 80px;
		}
	}

	.progress {
		background-color: #69a5f0;
		height: 8px;
		margin-top: -8px;
		margin-bottom: 8px;
		position: relative;
		overflow: visible;
		z-index: 1;

		&::before {
			background-color: #368bf3;
			content: '';
			display: block;
			height: 8px;
			left: 50%;
			position: absolute;
			top: -8px;
			width: 1px;
		}

		&.no-progress {
			background-color: rgba(#143958, 0.2);
		}

		::v-deep .progress-bar {
			background-color: #e55c5c;
		}
	}

	.votacion-stats {
		margin: 0 auto;

		.votacion-stat {
			text-align: center;
		}

		.votacion-stat-name,
		.votacion-stat-value {
			font-size: 13px;
			line-height: 15px;
			text-align: center;
		}

		.votacion-stat-name {
			color: #5c6981;
			margin-bottom: 4px;
		}

		.votacion-stat-value {
			color: #172a4c;
			font-weight: bold;
			margin-bottom: 0;
		}
	}
}

@media (min-width: 768px) {
	.content {
		margin-top: -39px;

		@at-root .iframe & {
			margin-bottom: 0;
			margin-top: 0;

			.votaciones-stats {
				padding-top: 27px;
			}

			.votaciones {
				max-height: 336px;
				overflow: auto;
				padding: 20px 0;
			}

			.votaciones [class^='col-'] {
				padding-bottom: 20px;

				.votacion.votacion-big .votacion-stats {
					margin-top: -20px;
				}
			}
		}
	}

	.votaciones,
	.votaciones-stats {
		max-width: 902px;
	}

	.votaciones-stats {
		padding-top: 38px;

		.votaciones-stats-percentage-container,
		.votaciones-stats-national-text,
		.progress {
			max-width: 320px;
		}

		.votaciones-stats-percentage-container {
			margin-bottom: 5px;
		}

		.votaciones-stats-national-text {
			margin-bottom: 9px;
		}

		.votaciones-stats-info {
			display: flex;
			flex-direction: column;
			justify-content: center;
		}

		.votaciones-stats-last-update,
		.votaciones-stats-info-text {
			text-align: right;
		}
	}

	.votacion-stats {
		max-width: 390px;
	}

	.votacion {
		&.votacion-big {
			.votacion-title {
				font-size: 20px;
				line-height: 24px;
			}
			.candidato {
				&.candidato-left {
					.candidato-img {
						margin-right: 20px;
					}

					.candidato-percentage {
						margin-right: 30px;
					}

					.ganador-badge {
						left: 134px;
					}
				}

				&.candidato-right {
					.candidato-img {
						margin-left: 20px;
					}

					.candidato-percentage {
						margin-left: 30px;
						order: 1;
					}

					.ganador-badge {
						right: 134px;
					}
				}

				.ganador-badge {
					font-size: 12px;
					line-height: 15px;
					padding: 4px 21px;
					top: 10px;
				}

				.candidato-img {
					height: 139px;
					width: 114px;
				}

				.candidato-stats {
					align-items: flex-end;
					flex-direction: row;
					margin-bottom: 34px;
				}

				.candidato-percentage {
					font-size: 26px;
					margin-bottom: 0;
				}

				.candidato-votos {
					font-size: 14px;
					line-height: 17px;
				}

				.candidato-name {
					font-size: 18px;
					line-height: 22px;
				}

				.fa-check {
					font-size: 15px;
					padding: 5px;
				}
			}

			.progress {
				height: 14px;
				margin-top: -14px;
			}
		}

		.progress::before {
			height: 10px;
			top: -10px;
		}

		.votacion-title {
			font-size: 16px;
			line-height: 19px;
		}

		.candidatos-container {
			.candidato-percentage {
				font-size: 24px;
				line-height: 29px;
			}

			.candidato-votos {
				font-size: 14px;
				line-height: 17px;
			}

			.candidato-name {
				font-size: 15px;
				line-height: 15px;
			}
		}
	}
}
</style>
